import React from "react";
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, ResponsiveContainer, PolarRadiusAxis } from "recharts";

export default function StatsRadar({ stats }) {
  const data = [
    { stat: "STR", value: stats?.strength ?? 5 },
    { stat: "DIS", value: stats?.discipline ?? 5 },
    { stat: "FOC", value: stats?.focus ?? 5 },
    { stat: "KNO", value: stats?.knowledge ?? 5 },
    { stat: "HLT", value: stats?.health ?? 5 },
  ];
  return (
    <div data-testid="stats-radar" className="w-full h-64">
      <ResponsiveContainer>
        <RadarChart data={data} outerRadius="72%">
          <PolarGrid stroke="rgba(139, 92, 246, 0.25)" />
          <PolarAngleAxis
            dataKey="stat"
            tick={{ fill: "#00E5FF", fontSize: 11, fontFamily: "Rajdhani", fontWeight: 700, letterSpacing: 2 }}
          />
          <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
          <Radar
            name="Hunter"
            dataKey="value"
            stroke="#00E5FF"
            fill="#8B5CF6"
            fillOpacity={0.35}
            strokeWidth={2}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
